import { Layout } from "antd";
import classNames from "classnames/bind";
import { useState } from "react";
import {
  Outlet,
  Navigate
} from "react-router-dom";
import { isUserLoggedIn } from "utils";
import { NavBar, SideBar } from "../components";
import style from './index.module.scss'

const { Content } = Layout;
const cx = classNames.bind(style)

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false)

  if (!isUserLoggedIn()) {
    return <Navigate to='/login' />
  }
  return (
    <Layout className={cx('layout')}>
      <SideBar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>
        <NavBar />
        <Content className={cx('content')}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
